<template>
  <v-card elevation="0" tile :color="bg_color" class="mx-5">
    <v-container class="py-0">
      <v-row justify="center">
        <v-card elevation="0" tile class="px-0" width="1200" :color="bg_color">
          <v-fab-transition>
            <v-btn
              :color="theme_color"
              dark
              absolute
              top
              left
              fab
              :x-large="!isSmall"
            >
              <v-icon color="white">{{ main_icon }}</v-icon>
            </v-btn>
          </v-fab-transition>
          <v-card-text>
            <v-list class="mb-10" :color="bg_color">
              <v-subheader class="px-0 mx-0 mt-5">
                <v-row justify="center" class="px-0 mx-0">
                  <v-col cols="3">
                    <span
                      :class="
                        isSmall
                          ? theme_text_color + ' subtitle-1'
                          : theme_text_color + ' title'
                      "
                    >
                      Coding Skills
                    </span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-subheader>
              <v-row justify="center" class="px-0 mx-0">
                <v-col
                  cols="6"
                  v-for="(item, index) in skills"
                  :key="index"
                  align-self="center"
                  align="center"
                  class="py-0 my-0"
                >
                  <v-row>
                    <v-col cols="3">
                      <v-icon :color="item.color" x-large>
                        {{ item.icon }}
                      </v-icon>
                      <br />
                      <span v-if="!isExSmall" class="subtitle-1 font-weight-light">
                        {{ item.name }}</span
                      >
                    </v-col>
                    <v-col align-self="center" align="center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-hover v-slot="{ hover }">
                            <v-progress-linear
                              :value="item.num"
                              :color="item.color"
                              :stream="hover ? true : false"
                              :buffer-value="hover ? 0 : 100"
                              height="15"
                              rounded
                              v-bind="attrs"
                              v-on="on"
                            >
                              <template v-slot:default="{ value }">
                                <strong class="white--text"
                                  >{{ Math.ceil(value) }}%</strong
                                >
                              </template>
                            </v-progress-linear>
                          </v-hover>
                        </template>
                        <span v-html="item.tooltip"></span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-list>
          </v-card-text>
        </v-card>
      </v-row>
      <v-divider></v-divider>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "education",
  created() {
    window.addEventListener("resize", this.cal_window);
  },
  destroyed() {
    window.removeEventListener("resize", this.cal_window);
  },
  mounted() {
    this.cal_window();
  },
  methods: {
    cal_window() {
      this.isSmall = window.innerWidth < 1264 ? true : false;
      this.isExSmall = window.innerWidth < 600 ? true : false;
    },
  },
  data: () => ({
    main_icon: "mdi-coffee",
    bg_color: "grey lighten-5",
    theme_color: "brown darken-3",
    theme_text_color: "brown--text text--darken-3",
    isSmall: false,
    isExSmall: false,
    proj_index: 0,
    skills: [
      {
        name: "Python",
        icon: "mdi-language-python",
        num: 80,
        text_color: "deep-purple--text text--darken-1",
        color: "deep-purple darken-1",
        tooltip: `Familiar with Numpy, Pandas, Matplotlib, Scikit-learn, <br/>
        OpenCV, Pytorch, PyQt5, Flask, PySQLite, PyMongo,<br/> 
        Beautifulsoup, Selenium...`,
      },
      {
        name: "JavaScript",
        icon: "mdi-language-javascript",
        num: 75,
        text_color: "amber--text text--darken-1",
        color: "amber darken-1",
        tooltip:
          "Familiar with JavaScript ES6, as well as HTML5 and basic CSS.",
      },
      {
        name: "Vue.js",
        icon: "mdi-vuejs",
        num: 75,
        text_color: "teal--text text--darken-2",
        color: "teal darken-2",
        tooltip: `Familiar with Vue.js and Vuetify.js as UI framework <br/>
        for web applications development.`,
      },
      {
        name: "D3.js",
        icon: "mdi-alpha-d-circle",
        num: 60,
        text_color: "orange--text text--darken-4",
        color: "orange darken-4",
        tooltip: `Familiar d3v5 for most types of scientific plottings, <br/>
        still learning for more fancy d3 visualizations.`,
      },
      {
        name: "MATLAB",
        icon: "$matlab_icon",
        num: 70,
        text_color: "blue-grey--text text--darken-1",
        color: "blue-grey darken-1",
        tooltip: `Familiar data analysis and visualization with MATLAB,  <br/>
        and used it for software development.`,
      },
      {
        name: "R",
        icon: "mdi-language-r",
        num: 50,
        text_color: "light-blue--text text--darken-3",
        color: "light-blue darken-3",
        tooltip: `Familiar with syntax and basic packages,<br/>
        can extend its usage if necessary.`,
      },
    ],
  }),
};
</script>
<style scoped>
/* div {
  outline: 1px dashed blue;
} */
</style>